import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-stone-50/80 backdrop-blur-sm border-b border-stone-200" data-id="element-113">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-114">
        <div className="flex items-center" data-id="element-115">
          <div className="h-10 w-10 bg-red-700 rounded-full flex items-center justify-center mr-3" data-id="element-116">
            <span className="text-white text-lg" data-id="element-117">安</span>
          </div>
          <h1 className="text-xl text-stone-800" data-id="element-118">潘 安</h1>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-119">
          {[{
          text: '我',
          key: 'Home'
        }, {
          text: '关于',
          key: 'Skills'
        }, {
          text: '项目',
          key: 'Projects'
        }, {
          text: '联系我',
          key: 'Contact'
        }].map(item => <a key={item.key} href={`#${item.key.toLowerCase()}`} className="text-stone-600 hover:text-red-700 transition-colors duration-300" data-id="element-120">
              {item.text}
            </a>)}
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-stone-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-121">
          {isMenuOpen ? <XIcon size={24} data-id="element-122" /> : <MenuIcon size={24} data-id="element-123" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-stone-50 border-t border-stone-200" data-id="element-124">
          <div className="container mx-auto px-4 py-4" data-id="element-125">
            <nav className="flex flex-col space-y-4" data-id="element-126">
              {['Home', 'About', 'Skills', 'Projects', 'Contact'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="text-stone-600 hover:text-red-700 transition-colors duration-300 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-127">
                    {item}
                  </a>)}
            </nav>
          </div>
        </div>}
    </header>;
};